const getCdnUrl = (path) => 'https://d3u51bgj2n3r2l.cloudfront.net'.concat(path);

export default getCdnUrl;
